import { useT } from '@/i18n';
import { TOKENS } from '@/styles/tokens';
import type { OrderStatus, ReportStatus } from '@/api/types';
import { cx } from './cx';

const pillClass = 'inline-flex items-center rounded-pill px-3 py-1 text-label';

export interface StatusPillProps {
  status: ReportStatus;
  className?: string;
}

export const StatusPill = ({ status, className = '' }: StatusPillProps) => {
  const t = useT();
  const style = TOKENS.status[status];
  return (
    <span className={cx(pillClass, className)} style={{ backgroundColor: style.bg, color: style.fg }}>
      {t(`status.${status}`)}
    </span>
  );
};

export interface OrderPillProps {
  status: OrderStatus;
  className?: string;
}

export const OrderPill = ({ status, className = '' }: OrderPillProps) => {
  const t = useT();
  const style = TOKENS.order[status];
  return (
    <span className={cx(pillClass, className)} style={{ backgroundColor: style.bg, color: style.fg }}>
      {t(`order.${status}`)}
    </span>
  );
};
